import {
    Autocomplete,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

import TextField from "../../../../../components/TextField";
import Button from "../../../../../components/Button";

import useMutation from "../../../../../hooks/useMutate";

import TeamsApi from "../../../../../services/SellersApi/teamsApi";
import { useForm } from "react-hook-form";
import useSalesAreas from "../../../../../hooks/SalesBonusApi/useSalesAreas";
import { ITeams } from "../../../../../interfaces/SellersApi/ITeams";

const teamsApi = new TeamsApi();

interface IEditTeamDialog {
    openDialog: boolean;
    setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
    team: ITeams;
}

const EditTeamDialog = ({
    openDialog,
    setOpenDialog,
    team,
}: IEditTeamDialog) => {
    const roles = ["Hunter", "Farm"];

    const {
        data: getSalesAreasResponse,
        isFetching: gettingSalesAreasResponse,
    } = useSalesAreas();

    const { mutate: editTeam, isLoading: editingTeam } = useMutation({
        successText: "Equipe editada.",
        errorText: "Falha ao editar equipe.",
        queryKeyArray: ["teams"],
        callback: teamsApi.put,
    });

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm<ITeams>({
        defaultValues: team,
    });

    const handleSubmitForm = (data: ITeams) => {
        editTeam({ id: team.id!, object: data });
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    return (
        <Dialog open={openDialog} onClose={handleClose}>
            <DialogTitle sx={{ backgroundColor: "primary.main" }}>
                <Typography textAlign={"center"} variant="h3" color={"#FAFAFA"}>
                    Editar {team.name}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box marginTop={"10px"}>
                    <TextField
                        fullWidth
                        {...register("name", { required: true })}
                        label="Nome*"
                        error={!!errors?.name}
                        helperText={<>{errors?.name?.message}</>}
                    />
                </Box>
                <Autocomplete
                    id="tags-standard"
                    options={roles}
                    getOptionLabel={(option) => option}
                    defaultValue={team.role}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            label="Função*"
                            {...register("role", { required: true })}
                            error={!!errors?.role}
                            helperText={<>{errors?.role?.message}</>}
                        />
                    )}
                />
                <Autocomplete
                    id="tags-standard"
                    loading={gettingSalesAreasResponse}
                    options={
                        getSalesAreasResponse?.results
                            ? getSalesAreasResponse?.results
                            : []
                    }
                    getOptionLabel={(option) => option.name}
                    defaultValue={{ name: team.area }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            label="Area de atuação*"
                            {...register("area", { required: true })}
                            error={!!errors?.area}
                            helperText={<>{errors?.area?.message}</>}
                        />
                    )}
                />
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                    onClick={handleSubmit(handleSubmitForm)}
                    loading={editingTeam}
                >
                    <Typography variant="body2">EDITAR</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditTeamDialog;
